import React from 'react';
import { TableCell, TableRow, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useEsgTaxonomy } from 'src/Esg/hooks';

import {
  ExpenditureAnalytics,
  ExpenditureType,
  TaxonomyReportAnalytics,
} from '../../../types';
import { toCurrency, toPercentage } from 'src/Esg/Taxonomy/utils';

interface Props {
  type: ExpenditureType;
}

export default function SumRows({ type }: Readonly<Props>) {
  const { t } = useTranslation('esg', {
    keyPrefix: 'taxonomy.activities.expenditure.table',
  });

  const { taxonomyReport, reportAnalytics } = useEsgTaxonomy();

  if (reportAnalytics.isLoading) return null;

  const analytics = reportAnalytics._instance?.[
    type.toLocaleLowerCase() as keyof TaxonomyReportAnalytics
  ] as ExpenditureAnalytics;

  return (
    <>
      <TableRow>
        <TableCell>
          <Typography>{t('activitiesNotIncluded')}</Typography>
        </TableCell>
        <TableCell colSpan={4} />
        <TableCell>
          {toCurrency(
            analytics?.non_eligible_value,
            taxonomyReport?.currency_type
          )}
        </TableCell>
        <TableCell>
          {toPercentage(analytics?.non_eligible_percentage)}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell>
          <Typography>{t('total')}</Typography>
        </TableCell>
        <TableCell colSpan={4} />
        <TableCell>
          {toCurrency(analytics?.total_value, taxonomyReport?.currency_type)}
        </TableCell>
        <TableCell />
      </TableRow>
      {analytics?.error_values && (
        <TableRow>
          <TableCell colSpan={7}>
            <Typography color="error" variant="body2" textAlign="right">
              {t('error')}
            </Typography>
          </TableCell>
        </TableRow>
      )}
    </>
  );
}
